import { render, staticRenderFns } from "./TestKitInfo.vue?vue&type=template&id=5e5dc994&scoped=true&"
import script from "./TestKitInfo.vue?vue&type=script&lang=js&"
export * from "./TestKitInfo.vue?vue&type=script&lang=js&"
import style0 from "./TestKitInfo.vue?vue&type=style&index=0&id=5e5dc994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5dc994",
  null
  
)

export default component.exports